export const findKeyesThatDiffs = <itemType extends Record<string, any>>(
	items: itemType[],
	keyesToLook: Array<keyof itemType>
) => {
	const difs: { [key in keyof itemType]?: boolean } = {};
	const prev: { [key in keyof itemType]?: any } = {};
	let difsAmount = 0;
	for (const item of items) {
		if (difsAmount === keyesToLook.length) break;
		for (const key of keyesToLook) {
			if (key in difs) continue;
			let objValue: any;
			if (typeof item[key] === "function") {
				objValue = item[key]();
			} else {
				objValue = item[key];
			}
			if (!(key in prev)) {
				prev[key] = objValue;
				continue;
			}
			if (prev[key] !== objValue) {
				difsAmount++;
				difs[key] = true;
			}
		}
	}

	return difs;
};

export const removeDuplicates = <T>(items: T[], getUniqueProperty: (item: T) => any): T[] => {
	const seenValues = new Set();
	return items.filter((item) => {
		const value = getUniqueProperty(item);
		if (seenValues.has(value)) {
			return false;
		}
		seenValues.add(value);
		return true;
	});
};
